import { AsyncPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { BreachHistoryChartComponent } from '../../../../breach-history-chart/breach-history-chart.component';
import { RuleEvaluation } from '../../../component-sidebar.types';
import { ComponentRuleBreachDetailsService } from '../component-rule-breach-details.service';

@Component({
  selector: 'twaice-fe-alerts-component-rule-evaluations-chart',
  imports: [AsyncPipe, BreachHistoryChartComponent],
  templateUrl: './component-rule-evaluations-chart.component.html',
})
export class ComponentRuleEvaluationsChartComponent implements OnInit {
  @Input() ruleBk: string;
  ruleEvaluations$: Observable<RuleEvaluation[] | null> = of(null);
  lookbackDays$: Observable<number> = of(0);
  requestedWindow$: Observable<BreachHistoryChartComponent['requestedWindow']> = of(null);
  storageTimezone$: Observable<string | null>;
  isLoading$ = of(true);
  emptyState$ = of(false);
  errorState$ = of(false);

  constructor(private componentRuleBreachDetailsService: ComponentRuleBreachDetailsService) {
    this.storageTimezone$ = this.componentRuleBreachDetailsService.getStorageTimezone$();
  }

  ngOnInit() {
    this.ruleEvaluations$ = this.componentRuleBreachDetailsService.getRuleEvaluations$(this.ruleBk);
    this.lookbackDays$ = this.componentRuleBreachDetailsService.getSidebarLookbackDays$();
    this.requestedWindow$ = this.componentRuleBreachDetailsService
      .getRequestedTimeRange$()
      .pipe(
        map((timeRange) =>
          timeRange ? { start: new Date(timeRange.start).getTime(), end: new Date(timeRange.end).getTime() } : null
        )
      );

    const chartState = this.componentRuleBreachDetailsService.getRuleEvaluationsChartState(this.ruleBk);
    this.isLoading$ = chartState.isLoading$;
    this.emptyState$ = chartState.emptyState$;
    this.errorState$ = chartState.errorState$;
  }
}
